import React from "react";
import { UserCheck } from "lucide-react";
import SettingsListPanel from "./SettingsListPanel";

const EmploymentStatusesManagement = () => (
  <SettingsListPanel
    config={{
      title: "Employment Statuses",
      subtitle: "Manage employment statuses",
      icon: UserCheck,
      endpoint: "/api/settings/employment-statuses",
      itemLabel: "Employment Status",
      columnLabel: "Name",
      placeholder: "Enter employment status name",
    }}
  />
);

export default EmploymentStatusesManagement;
